import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CircularProgressCentered = styled(CircularProgress)({
  position: 'absolute',
  left: '50%',
  top: '50%',
  marginTop: -22,
  marginLeft: -22,
});
